module.exports = __webpack_public_path__ + "img/venta_4.ac177abc.png";